import React, { useState, useContext, useEffect } from 'react';
import { Nav, Tab, Modal } from 'react-bootstrap';
import { NavItem, NavLink, TabsWrap } from '@/shared/components/Tabs';
import { FaPlus } from 'react-icons/fa';
import { Button } from '@/shared/components/Button';
import toast from 'react-hot-toast';
import RequestList from './RequestList';
import Search from './Search';
import { RestaurantContext } from '../../../../context/RestaurantContext';
import ResaurantDetails from './Resaurantdetails';
import { AuthContext } from '../../../../context/AuthContext';
import PrimaryContactForm from './PrimaryContactForm';
import { PermissionContext } from '../../../../context/PermissionContext';
import { ThemeContext } from '../../../../context/ThemeContext';
import RejectedRequest from './RejectRequestTab/RejectedRequest';



const Tabs = () => {
  // state for component condition rendering 
  const { permissionsAccess } = useContext(PermissionContext);
  const { currentTheme } = useContext(ThemeContext);
  const { apiGlobal, userid } = useContext(AuthContext);
  // const [condition, setCondition] = useState('searchRestaurant');
  const {
    setRefresh,
    showModal,
     setShowModal,
     isDetailsClick, 
     click, 
     setclick,
     activeKey, 
     setActiveKey,
     } = useContext(RestaurantContext);



  const AddNewRestaurant = async (values) => {
    // console.log(`You submitted:\n\n${JSON.stringify(values, null, 2)}`);
    if (values.accountNo !== values.conAccount) {
      toast.error('Account numbers do not match. Please check and try again.');
      return;
    }

    if (!values.accCountry) {
      toast.error('Please select a account country');
      return;
    }
    if (!values.country) {
      toast.error('Please select a  country');
      return;
    }

    const formData = new FormData();
    formData.append('user_name', values.userName);
    formData.append('user_phone', values.userPhone);
    formData.append('user_email', values.userEmail);
    formData.append('uin', values.uin);
    formData.append('acc_name', values.accName);
    formData.append('country_code', values.countryCode);
    formData.append('country', values.country.value);
    formData.append('acc_country', values.accCountry.value);
    formData.append('account_no', values.accountNo);
    formData.append('acc_city', values.accCity);
    formData.append('branch', values.branch);
    formData.append('ifsc_code', values.ifscCode);
    formData.append('bank', values.bank);
    formData.append('photo', values.file);
    formData.append('type', 0);
    formData.append('user_id', userid);
   
    // for log form Data
    // formData.forEach((value, key) => {
    //   console.log(`${key}: ${value}`);
    // });
        try {
        const response = await fetch(`${apiGlobal}/restaurant_add.php`, {
            method: 'POST',
            body: formData,
        });
        const responseData = await response.json();
        // console.log(responseData);
        if (responseData.status && responseData.message === 'Data inserted successfully.') {
            toast.success('Restaurant Added Successfully...');
            setRefresh(prev => !prev);
            setShowModal(false);
        } else {
            toast.error(responseData.message);
        }
    } catch (error) {
        toast.error(error.message);
    }    
  };
  
    useEffect(() => {
      if (isDetailsClick) {
        setActiveKey('2');
        setclick('detailsClick');
      }
    }, [isDetailsClick]);

  return (
    <>
      {/* Tabs */}
      <Tab.Container activeKey={activeKey} onSelect={key => setActiveKey(key)}>
        <TabsWrap>
          {permissionsAccess?.[1]?.master_id === '2'
        && permissionsAccess?.[1]?.create === 1 && (
          <Button 
            variant="outline-primary" 
            size="sm" 
            onClick={() => setShowModal(true)}
          >
            <span>Add Restaurant</span><FaPlus />
          </Button>
        )}
          <Nav className="nav-tabs">
            <NavItem>
              <NavLink eventKey="1" disabled={isDetailsClick}>Search</NavLink>
            </NavItem>
            <NavItem>
              <NavLink eventKey="2" disabled={!isDetailsClick}>Details</NavLink>
            </NavItem>
            {/* <NavItem>
              <NavLink eventKey="3" disabled={isDetailsClick}>Request</NavLink>
            </NavItem>
            <NavItem>
              <NavLink 
                eventKey="4" 
                disabled={isDetailsClick}
              >
                <span style={{ color: 'red' }}>
                  Rejected Request
                </span>
              </NavLink>
            </NavItem> */}
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="1">
              {click === 'searchSelect' && <Search />}
            </Tab.Pane>
            <Tab.Pane eventKey="2">
              {click === 'detailsClick' && <ResaurantDetails setActiveKey={setActiveKey} />}
            </Tab.Pane>
            {/* <Tab.Pane eventKey="3">
              <RequestList />
            </Tab.Pane>
            <Tab.Pane eventKey="4">
              <RejectedRequest />
            </Tab.Pane> */}
          </Tab.Content>
        </TabsWrap>
      </Tab.Container>

      {/* Modal for Adding Restaurant */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="xl"
      >
        <Modal.Header
          style={{
          backgroundColor: currentTheme === 'Dark' && '#232329',
          color: currentTheme === 'Dark' && '#fff',
        }}
          closeButton
          closeVariant={currentTheme === 'Dark' && 'white'}
        >
          <Modal.Title>Add Restaurant</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
          backgroundColor: currentTheme === 'Dark' && '#232329',
        }}
        >
          <PrimaryContactForm onSubmit={AddNewRestaurant} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Tabs;
